import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import loadOrderByOrderNumberCustom from "@WhiteCap/Handlers/OrderDetails/LoadOrderbyOrderNumberCustom";
import { CustomApiHandlerDiscreteParameter } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getOrderDetailsState } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderDeatilsCustom/OrderDetailsCustomSelector";

type HandlerType = CustomApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails")[] },
    GetOrderApiParameter,
    OrderModel
>;

export const DispatchSetOrderNumber: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/SetOrderNumber",
        orderNumber: props.parameter.orderNumber,
    });
};

export const DispatchLoadOrderIfNeeded: HandlerType = props => {
    const orderState = getOrderDetailsState(props.getState(), props.parameter.orderNumber);
    if (!orderState.isLoading) {
        props.dispatch(loadOrderByOrderNumberCustom(props.parameter));
    }
};

export const chain = [DispatchSetOrderNumber, DispatchLoadOrderIfNeeded];

const displayOrderCustom = createHandlerChainRunner(chain, "DisplayOrderCustom");
export default displayOrderCustom;
